export const TypeOfAuth = {
    NonAuth: 0,
    Auth: 1,
    Both: 2,
};